
import React from 'react';

const GameFeatures = () => {
  // SVG Icons for features
  const renderSVGIcon = (iconType) => {
    switch(iconType) {
      case 'time':
        return (
          <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 mb-4">
            <circle cx="30" cy="30" r="25" fill="#1A1F2C" stroke="#7E69AB" strokeWidth="2"/>
            <path d="M30 15 L30 30 L40 35" stroke="#9b87f5" strokeWidth="3" fill="none"/>
            <circle cx="30" cy="30" r="3" fill="#9b87f5"/>
          </svg>
        );
      case 'weapons':
        return (
          <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 mb-4">
            <rect x="10" y="25" width="40" height="10" rx="2" fill="#1A1F2C" stroke="#7E69AB" strokeWidth="2"/>
            <rect x="20" y="20" width="5" height="20" fill="#9b87f5"/>
            <rect x="50" y="27" width="5" height="6" fill="#9b87f5"/>
            <circle cx="15" cy="30" r="3" fill="#8B5CF6"/>
          </svg>
        );
      case 'missions':
        return (
          <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 mb-4">
            <rect x="10" y="10" width="40" height="40" rx="5" fill="#1A1F2C" stroke="#7E69AB" strokeWidth="2"/>
            <path d="M20 30 L25 35 L40 20" stroke="#9b87f5" strokeWidth="3" fill="none"/>
          </svg>
        );
      case 'graphics':
        return (
          <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 mb-4">
            <polygon points="30,10 45,20 45,40 30,50 15,40 15,20" fill="#1A1F2C" stroke="#7E69AB" strokeWidth="2"/>
            <circle cx="30" cy="30" r="10" fill="#9b87f5" fillOpacity="0.5"/>
          </svg>
        );
      case 'unblocked':
        return (
          <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 mb-4">
            <rect x="15" y="20" width="30" height="25" rx="3" fill="#1A1F2C" stroke="#7E69AB" strokeWidth="2"/>
            <rect x="25" y="15" width="10" height="10" rx="2" fill="#9b87f5"/>
            <circle cx="30" cy="32" r="5" fill="#8B5CF6"/>
            <path d="M30 35 L30 40" stroke="#8B5CF6" strokeWidth="3"/>
          </svg>
        );
      case 'online':
        return (
          <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 mb-4">
            <circle cx="30" cy="30" r="25" fill="#1A1F2C" stroke="#7E69AB" strokeWidth="2"/>
            <path d="M15 30 C15 20 45 20 45 30 C45 40 15 40 15 30" stroke="#9b87f5" strokeWidth="2" fill="none"/>
            <circle cx="30" cy="30" r="5" fill="#8B5CF6"/>
          </svg>
        );
      default:
        return null;
    }
  };

  const features = [
    {
      id: 'time',
      title: 'Time Manipulation',
      description: 'Slow down time to plan your shots perfectly and execute complex tactical maneuvers that would be impossible at regular speed.'
    },
    {
      id: 'weapons',
      title: 'Arsenal of Weapons',
      description: 'Choose from a wide variety of realistic SWAT weapons including assault rifles, shotguns, pistols, sniper rifles, and special tactical equipment.'
    },
    {
      id: 'missions',
      title: 'Varied Missions',
      description: 'Take on diverse mission objectives from hostage rescue to bomb defusal across multiple unique and challenging environments.'
    },
    {
      id: 'graphics',
      title: 'Immersive Graphics',
      description: 'Experience high-quality 3D graphics optimized for browser play, with detailed environments and realistic effects.'
    },
    {
      id: 'unblocked',
      title: 'Always Unblocked',
      description: 'Play Time Shooter 3 unblocked anytime, anywhere, without worrying about network restrictions at school or work.'
    },
    {
      id: 'online',
      title: 'Free Online Play',
      description: 'No downloads or installations required. Jump straight into the action directly from your web browser, completely free.'
    }
  ];

  return (
    <section className="my-16" id="features">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold mb-10 text-center text-purple-300">Game Features</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div key={feature.id} className="bg-indigo-900/40 p-6 rounded-xl hover:bg-indigo-800/40 transition-colors duration-300 flex flex-col items-center text-center">
              {renderSVGIcon(feature.id)}
              <h3 className="text-xl font-bold mb-3 text-purple-300">{feature.title}</h3>
              <p className="text-indigo-100">{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-12 bg-gradient-to-r from-purple-900/50 to-indigo-900/50 p-8 rounded-xl">
          <h3 className="text-2xl font-bold mb-4 text-center text-purple-300">Why Play Time Shooter 3 Unblocked?</h3>
          <p className="text-lg mb-6 text-center text-indigo-100">
            Time Shooter 3 Unblocked combines tactical depth with fast-paced action, providing a premium FPS experience directly in your browser. Whether you're a casual gamer looking for quick action or an FPS enthusiast seeking strategic challenges, this free online game delivers an unmatched experience with its unique time-manipulation mechanics and varied mission objectives.
          </p>
          
          <div className="flex justify-center">
            <a href="#play-now" className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105 hover:shadow-lg">
              Play For Free Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GameFeatures;
